/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnumerationOptionDto } from './EnumerationOptionDto';
import {
    instanceOfEnumerationOptionDto,
    EnumerationOptionDtoFromJSON,
    EnumerationOptionDtoFromJSONTyped,
    EnumerationOptionDtoToJSON,
} from './EnumerationOptionDto';

/**
 * @type EnumerationValueDtoValue
 * 
 * @export
 */
export type EnumerationValueDtoValue = EnumerationOptionDto;


export function EnumerationValueDtoValueFromJSON(json: any): EnumerationValueDtoValue {
    return EnumerationValueDtoValueFromJSONTyped(json, false);
}

export function EnumerationValueDtoValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationValueDtoValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...EnumerationOptionDtoFromJSONTyped(json, true) };
    return  EnumerationOptionDtoFromJSONTyped(json, true);
}

export function EnumerationValueDtoValueToJSON(value?: EnumerationValueDtoValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfEnumerationOptionDto(value)) {
        return EnumerationOptionDtoToJSON(value as EnumerationOptionDto);
    }

    return {};
}

/**
 * Check if a given object implements the EnumerationValueDtoValue interface.
 */
export function instanceOfEnumerationValueDtoValue(value: any): value is EnumerationValueDtoValue {
    if (instanceOfEnumerationOptionDto(value)) return true;
    return false;
}

